const indexItems = [
  { title: '动作冒险大片合集', count: '1,286部', icon: 'ri-sword-line', color: 'text-red-500' },
  { title: '悬疑烧脑高分片单', count: '872部', icon: 'ri-lightbulb-line', color: 'text-purple-500' },
  { title: '治愈系温暖电影推荐', count: '654部', icon: 'ri-heart-line', color: 'text-pink-500' },
  { title: '科幻史诗视觉盛宴', count: '943部', icon: 'ri-rocket-line', color: 'text-blue-500' },
  { title: '喜剧爆笑减压合集', count: '1,105部', icon: 'ri-emotion-laugh-line', color: 'text-orange-500' },
  { title: '国产剧年度口碑榜', count: '512部', icon: 'ri-tv-line', color: 'text-red-600' },
  { title: '韩剧精选高分推荐', count: '438部', icon: 'ri-heart-pulse-line', color: 'text-rose-500' },
  { title: '动漫热血战斗专场', count: '1,340部', icon: 'ri-fire-line', color: 'text-amber-500' },
  { title: '纪录片自然与人文', count: '780部', icon: 'ri-earth-line', color: 'text-green-500' },
];

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            分类导航
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            按类型与主题精心整理的影视分类，快速找到想看的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-4 p-5 md:p-6 rounded-2xl bg-white hover:bg-primary-50/20 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-background-100 flex items-center justify-center shrink-0 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${item.icon} text-xl ${item.color}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </div>
                <div className="text-xs text-foreground-400 mt-1">{item.count} 部作品</div>
              </div>
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}